<mh-alerts-wrapper>

  <section mhFilterBar>
    <div mhFilterGroup>
      <div>
        <mh-core-lib-datepicker
            [currentDates]="currentDates"
            [currentFilter]="currentFilterDate"
            (datepickerUpdated)="handleDatepickerUpdated($event)">
        </mh-core-lib-datepicker>
      </div>
      <ng-container *ngIf="fidelityPermisions.includes('interchain_online_coverage_hotel_result')">
        <mh-core-lib-filter-chain-zone [productId]="productId" (chainChanged)="setChain($event)" [disabled]="!isReady"></mh-core-lib-filter-chain-zone>
        <mh-core-lib-filter-hotels requireSelection [chainFilter]="hotelOptions" (hotelsChanged)="setHotelsFilter($event)"></mh-core-lib-filter-hotels>
      </ng-container>
    </div>
    <div>
      <mh-filter-date
          [startDate]="startDate"
          [endDate]="endDate"
          [report]="fidelityPermisions.includes('interchain_online_coverage_hotel_report') ? 'chainOnlineCoverageCustomer' : null "
          [reportActiveEmail]="true"
          [checkPermissions]="true"
          slug="corporative_online_coverage_hotel_report">
      </mh-filter-date>
    </div>
  </section>
  <mh-box-element [title]="titleTranslatePath | translate " *ngIf="fidelityPermisions.includes('interchain_online_coverage_hotel_result')">
    <div class="tw-flex tw-justify-end">
      <widget-modal-faq
        [faqs]="faqs"
        [prefixTranslate]="prefixTranslateFAQ"
        ></widget-modal-faq>
    </div>

    <mh-spinner-classic [hidden]="!waiting"></mh-spinner-classic>
    <ng-container *ngIf="!waiting">
      <widgets-table-periods
        [dataSource]="dataSource"
        [headerTable]="headerTable"
        [chain]="chainActives"
        [totals]="totals"
        [prefixTranslate]="'inter-chain.online.table'"
      ></widgets-table-periods>
    </ng-container>

  </mh-box-element>

</mh-alerts-wrapper>
